import styled from "styled-components";
import Reveal from "../ui/Reveal";
import SectionLabel from "../ui/SectionLabel";
import { skillGroups } from "../../data/skills";

function Skills() {
  return (
    <Section id="skills" aria-labelledby="skills-heading">
      <SectionLabel>Skills</SectionLabel>
      <Reveal as="h2" id="skills-heading">
        Tools I use to ship products.
      </Reveal>
      <Grid>
        {skillGroups.map((group, index) => (
          <Reveal as="div" delay={index * 0.05} key={group.label}>
            <GroupCard>
              <h3>{group.label}</h3>
              <ul>
                {group.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </GroupCard>
          </Reveal>
        ))}
      </Grid>
    </Section>
  );
}

const Section = styled.section`
  max-width: 1240px;
  margin: auto;
  padding: 0 28px 100px;

  @media (max-width: 700px) {
    padding: 0 24px 70px;
  }

  h2 {
    font-size: clamp(2.2rem, 4.2vw, 3.6rem);
    letter-spacing: -0.03em;
    line-height: 1.1;
    color: var(--text-primary);
    margin: 0 0 52px;
    max-width: 640px;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

const GroupCard = styled.div`
  height: 100%;
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 24px 22px;
  background: var(--bg-elevated);
  transition: border-color 0.2s ease, transform 0.2s ease;

  &:hover {
    border-color: var(--accent);
    transform: translateY(-2px);
  }

  h3 {
    margin: 0 0 16px;
    font-size: 0.95rem;
    font-weight: 800;
    color: var(--accent);
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  li {
    color: var(--text-primary);
    font-size: 0.92rem;
    font-weight: 600;
  }
`;

export default Skills;
